import { Navigate, useLocation, useParams } from 'react-router-dom';

/** `/insurance-ar` (and `/insurance-ar/*`) → `/ar`, keeping any claim id and query string. */
export function ArRedirect() {
  const { '*': rest } = useParams();
  const { search } = useLocation();
  const tail = rest ? `/${rest}` : '';
  return <Navigate to={`/ar${tail}${search}`} replace />;
}
